import { HttpErrorResponse } from '@angular/common/http';
import { MetaData, Supplier } from '@emi/shared/models';
import { createAction, props } from '@ngrx/store';

export const getSuppliers = createAction('[SupplierFilters] Get Suppliers');

export const getSuppliersSuccess = createAction(
    '[SupplierFilters] Get Suppliers Success',
    props<{ suppliers: Supplier[]; metadata: MetaData | null; searchText: string | null }>()
);

export const getSuppliersFailure = createAction('[SupplierFilters] Get Suppliers Failure', props<{ error: HttpErrorResponse }>());

export const fetchSuppliers = createAction('[SupplierFilters] Fetch Suppliers');

export const searchSuppliers = createAction('[SupplierFilters] Get Suppliers With Search', props<{ searchText: string; delay: number }>());

export const isLoadingSuppliers = createAction('[SupplierFilters] Loading Suppliers');

export const amendSupplierSelections = createAction('[SupplierFilters] Amend Selected Suppliers');

export const getNextPageSuppliers = createAction('[SupplierFilters] Get Next Page Suppliers');

export const updateSuppliersSelectionSuccess = createAction(
    '[SupplierFilters] Get Next Page Suppliers Success',
    props<{ suppliers: Supplier[]; metadata: MetaData | null }>()
);
